import React, { useState } from 'react';
import { Mail, Globe, MessageCircle, Send } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { t, isRTL } = useLang();
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const submit = (e) => {
    e.preventDefault();
    toast({ title: t.contact.sent });
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <main className="page-y min-h-screen">
      <div className="site-container">
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-3">{t.contact.title}</h1>
          <p className="text-slate-500">{t.contact.desc}</p>
        </div>
        <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1 space-y-4">
            {[
              { Ic: Mail, label: t.footer.email, dir: 'ltr' },
              { Ic: Globe, label: t.footer.phone },
              { Ic: MessageCircle, label: t.footer.address }
            ].map((it, i) => (
              <div key={i} className={`rounded-xl bg-white border border-slate-200 p-5 flex items-center gap-3 ${isRTL ? 'flex-row-reverse text-right' : ''}`}>
                <div className="w-11 h-11 rounded-lg bg-blue-50 flex items-center justify-center shrink-0"><it.Ic className="w-5 h-5 text-blue-600" /></div>
                <div className="text-slate-700 text-sm" dir={it.dir || (isRTL ? 'rtl' : 'ltr')}>{it.label}</div>
              </div>
            ))}
          </div>
          <form onSubmit={submit} className="lg:col-span-2 rounded-2xl bg-white border border-slate-200 p-6 space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="text-slate-600 text-sm mb-1.5 block">{t.contact.name}</label>
                <Input required value={form.name} onChange={update('name')} className="bg-slate-50 border-slate-200 text-slate-900 h-11" />
              </div>
              <div>
                <label className="text-slate-600 text-sm mb-1.5 block">{t.contact.email}</label>
                <Input required type="email" value={form.email} onChange={update('email')} className="bg-slate-50 border-slate-200 text-slate-900 h-11" />
              </div>
            </div>
            <div>
              <label className="text-slate-600 text-sm mb-1.5 block">{t.contact.subject}</label>
              <Input required value={form.subject} onChange={update('subject')} className="bg-slate-50 border-slate-200 text-slate-900 h-11" />
            </div>
            <div>
              <label className="text-slate-600 text-sm mb-1.5 block">{t.contact.message}</label>
              <Textarea required value={form.message} onChange={update('message')} rows={5} className="bg-slate-50 border-slate-200 text-slate-900 resize-none" />
            </div>
            <Button type="submit" className="btn-primary-blue border-0 h-12 px-7 font-semibold">
              <Send className={`w-4 h-4 ${isRTL ? 'ms-2 rtl-flip' : 'me-2'}`} />{t.contact.send}
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Contact;
